import Center from "../Base/Center";
import { cn } from "@/shared/utils/cn";
import { PaymentLedger } from "@/shared/utils/interfaces";
import { useTranslation } from "react-i18next";
import usePosPaymentHook from "@/shared/hooks/usePosPaymentHook";
import Icon, { IconsVariant } from "@/Components/Icon/Icon";
import Skeleton from "react-loading-skeleton";

const statusMap: Record<string, [string, IconsVariant, string]> = {
  unpaid: ["bg-error/20 text-error", "times", "fill-error"],
  paid: ["bg-success/20 text-success", "check", "fill-success"],
  pending: ["bg-primary/20 text-primary", "spinner", "fill-primary"],
};

const PaymentStatus = ({
  ledger,
  defaultLedger,
  isFetching,
}: {
  ledger: PaymentLedger;
  defaultLedger: PaymentLedger;
  isFetching: boolean;
}) => {
  const { t } = useTranslation();
  const { paymentList } = usePosPaymentHook(true);

  const paymentText = paymentList.find(
    (payment) =>
      payment.value === defaultLedger?.payment_method_id && ledger?.is_paid
  )?.translationKey;

  const isPendingPayment = Boolean(
    ledger.is_paid === false && ledger.item_id > 0 && ledger.transaction_email
  );

  const status = isPendingPayment ? "pending" : paymentText ? "paid" : "unpaid";

  return (
    <div
      className={cn(
        "flex items-center self-center px-4 py-1 rounded-lg gap-4 font-bold text-xl",
        isFetching ? "" : statusMap[status][0]
      )}
    >
      {isFetching ? (
        <Skeleton
          width="10rem"
          height="2.5rem"
          baseColor="var(--primary)"
          style={{ opacity: 0.25 }}
        />
      ) : (
        <>
          <p>{t(`${paymentText || "unpaid"}`)}</p>
          <Icon
            variants={statusMap[status][1]}
            className={cn("size-8", statusMap[status][2])}
          />
        </>
      )}
    </div>
  );
};

const SplitPaymentLedgerHeader = ({
  index,
  defaultLedger,
  ledger,
  isFetching,
}) => {
  return (
    <div className="px-6 py-1 bg-dark/10 rounded-t-2xl">
      <div className="flex gap-4 justify-between">
        <Center className="size-12 rounded-full text-3xl font-bold bg-dark text-white">
          {index + 1}
        </Center>
        <PaymentStatus
          ledger={ledger}
          defaultLedger={defaultLedger}
          isFetching={isFetching}
        />
      </div>
    </div>
  );
};

export default SplitPaymentLedgerHeader;
